import React from 'react';

const About = () => {
    return (
        <div className="m-6">
            <h1 className="text-xl font-bold leading-none text-black sm:text-2xl md:text-4xl">About</h1>
            <div className="p-3 font-medium">
                This is a movie web app where people can explore movies, and add movies to their favourites list and can also rate the moves and other users movie lists 🎬🍿.
            </div>
        </div>
    );
}

export default About;
